import {useMutation} from "@tanstack/react-query";
import {updateClaim} from "../services/ClaimService";

export function useClaimUpdate() {
    return useMutation({
        mutationFn: ({claimType, claimValue, payload}) => updateClaim(claimType, claimValue, payload),
    });
}
